import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/logo.png";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
    
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  return (
    <header className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        {/* LOGO SECTION */}
        <Link to="/" className="navbar-logo">
          <div className="logo-container">
            <img 
              src={logo} 
              alt="JCRL Cornerstone Technologies Pvt Ltd" 
              className="logo-image"
            />
            <div className="logo-text-container">
              <div className="logo-main">
                <span
                  className="logo-text"
                  style={{ fontSize: "38px", fontWeight: 700 }}
                >
                  JCRL
                </span>
                <div className="logo-badge">
                  <div style={{ fontSize: "14px", lineHeight: "1.2" }}>
                    <span style={{ fontWeight: 600 }}>CORNERSTONE</span>
                    <span style={{ fontWeight: 400, marginLeft: "8px" }}>
                      Technologies Pvt Ltd.
                    </span>
                  </div>
                  <div style={{ marginTop: "2px" }}>
                    <span
                      className="logo-tagline"
                      style={{ fontSize: "13px", color: "#0ddbfc", fontWeight: 400 }}
                    >
                      - Best Software Solution Provider -
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Link>

        {/* NAVIGATION LINKS */}
        <nav className={`navbar-links ${open ? "open" : ""}`}>
          <Link 
            to="/" 
            className={`nav-link ${isActive("/") ? "active" : ""}`}
            onClick={() => setOpen(false)}
          >
            <span className="nav-text">Home</span>
            <div className="nav-indicator"></div>
          </Link>
          
          <Link 
            to="/services" 
            className={`nav-link ${isActive("/services") ? "active" : ""}`}
            onClick={() => setOpen(false)}
          >
            <span className="nav-text">Services</span>
            <div className="nav-indicator"></div>
          </Link>
          
          <Link 
            to="/about" 
            className={`nav-link ${isActive("/about") ? "active" : ""}`}
            onClick={() => setOpen(false)}
          >
            <span className="nav-text">About</span>
            <div className="nav-indicator"></div>
          </Link>
          
          <Link 
            to="/contact" 
            className={`nav-link ${isActive("/contact") ? "active" : ""}`}
            onClick={() => setOpen(false)}
          >
            <span className="nav-text">Contact</span>
            <div className="nav-indicator"></div>
          </Link>
        </nav>

        {/* MOBILE MENU BUTTON */}
        <button
          className={`mobile-menu-btn ${open ? "open" : ""}`}
          onClick={() => setOpen(!open)}
          aria-label="Toggle Menu"
        >
          <div className="menu-line line-1"></div>
          <div className="menu-line line-2"></div>
          <div className="menu-line line-3"></div>
        </button>
      </div>

      {/* MOBILE MENU OVERLAY */}
      {open && (
        <div className="mobile-menu-overlay" onClick={() => setOpen(false)}>
          <div className="mobile-menu-content" onClick={(e) => e.stopPropagation()}>
            <div className="mobile-menu-header">
              <Link to="/" className="mobile-logo-container" onClick={() => setOpen(false)}>
                <img 
                  src={logo} 
                  alt="JCRL Cornerstone Technologies" 
                  className="mobile-logo-image"
                />
                <div className="mobile-logo-text-container">
                  <div style={{ fontSize: "12px", lineHeight: "1.2" }}>
                    <span style={{ fontSize: "24px", fontWeight: 700 }}>JCRL</span>
                    <div style={{ marginTop: "2px" }}>
                      <span style={{ fontWeight: 600 }}>CORNERSTONE</span>
                      <span style={{ fontWeight: 400, marginLeft: "4px" }}>
                        Technologies Pvt Ltd.
                      </span>
                    </div>
                  </div>
                  <div style={{ marginTop: "4px" }}>
                    <span 
                      className="mobile-logo-tagline" 
                      style={{ fontSize: "11px", color: "#0ddbfc", fontWeight: 400 }}
                    >
                      - Best Software Solution Provider -
                    </span>
                  </div>
                </div>
              </Link>
            </div>
            
            <div className="mobile-menu-links">
              <Link 
                to="/" 
                className={`mobile-nav-link ${isActive("/") ? "active" : ""}`}
                onClick={() => setOpen(false)}
              >
                <span className="mobile-nav-text">Home</span>
                <div className="mobile-nav-icon">🏠</div>
              </Link>
              
              <Link 
                to="/services" 
                className={`mobile-nav-link ${isActive("/services") ? "active" : ""}`}
                onClick={() => setOpen(false)}
              >
                <span className="mobile-nav-text">Services</span>
                <div className="mobile-nav-icon">🛠️</div>
              </Link>
              
              <Link 
                to="/about" 
                className={`mobile-nav-link ${isActive("/about") ? "active" : ""}`}
                onClick={() => setOpen(false)}
              >
                <span className="mobile-nav-text">About</span>
                <div className="mobile-nav-icon">ℹ️</div>
              </Link>
              
              <Link 
                to="/contact" 
                className={`mobile-nav-link ${isActive("/contact") ? "active" : ""}`}
                onClick={() => setOpen(false)}
              >
                <span className="mobile-nav-text">Contact</span>
                <div className="mobile-nav-icon">📞</div>
              </Link>
            </div>
            
            <div className="mobile-menu-footer">
              <Link 
                to="/contact" 
                className="mobile-cta-btn"
                onClick={() => setOpen(false)}
              >
                <span>Get Free Consultation</span>
                <div className="mobile-cta-arrow">→</div>
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;